import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin(() => {
    const { proxy, onLoaded } = useScriptPostHog()

    onLoaded(({ posthog }) => {
        if (import.meta.env.MODE === 'development') {
            posthog.debug()
        }

        // Local dev shares the production PostHog token; drop everything captured
        // from a .localhost host so dev-only noise never files production issues.
        const host = globalThis.location?.hostname ?? ''
        if (host === 'localhost' || host.endsWith('.localhost')) {
            posthog.set_config({ before_send: () => null })
        }
    })

    // `fullPath` without the trailing `#fragment`, so two routes that differ
    // only by their anchor compare as equal.
    const pathWithoutHash = route => route.fullPath.split('#')[0]

    const router = useRouter()
    router.afterEach((to, from) => {
        // A table-of-contents / anchor click changes only the URL hash and
        // keeps the user on the same page. It is the sole pageview source
        // (`capturePageview: false` in nuxt.config.ts), so without this guard
        // each anchor click emits a full $pageview plus a page_scroll reset.
        // That inflates pageview counts and resets scroll-depth tracking on
        // every article that has a table of contents.
        if (pathWithoutHash(to) === pathWithoutHash(from) && to.hash !== from.hash) {
            return
        }

        nextTick(() => {
            if (from.fullPath === to.fullPath) {
                proxy.posthog.capture('$pageleave', {
                    current_url: from.fullPath,
                })
            }

            proxy.posthog.capture('$pageview', {
                current_url: to.fullPath,
            })

            proxy.posthog.capture('page_scroll', { percentage: 0 })
        })
    })
})
